export enum SupportLocale {
  // AR='ar',
  EN_US = 'en-US',
  ES = 'es', // 西班牙
  ID = 'id',
  JA = 'ja', // 日本
  KO = 'ko',
  MS = 'ms',
  PT = 'pt', // 葡萄牙
  RU = 'ru', // 俄罗斯
  UK = 'uk', // 乌克兰
  ZH_CN = 'zh-CN',
  ZH_TW = 'zh-TW',
}

export const enum StorageKey {
  LOGIN_SCENE = 'pp_login_scene', // 登录组件被调起的场景
  LOCALE = 'pp_locale',
  ACCESS_TO_VISIT = 'pp_access_to_visit',
  SHARE_PASSCODE_TOKEN = 'pp_share_passcode_token',
  PREVIEW_FILE_ID = 'pp_preview_file_id', // 分享页预览文件时记录
  SAVED_FILE_IDS = 'pp_saved_file_ids', // 记录已保存的文件 id
  USER_ID = 'pp_user_id', // 用户 id，为了能在 SSR 阶段提前渲染，防止选出现为登录，然后再登录
  NAV_FOLDERS = 'pp_nav_folders', // 目录面包屑中的目录数据，缓存于 sessionStorage
  OAUTH_INFO_KEY = 'pp_oauth_info',
  RESTORE_CONTINUE = 'pp_restore_continue', // 调起登录框时需要展示，第三方登录返回后，用这个值判断是否重新转存
  RESTORE_TO_DRIVE = 'pp_restore_to_drive', // 第三方登录返回后，转存成功是否前往云盘消费
  RESTORE_REQUEST_BODY = 'pp_restore_request_body', // 转存接口中使用的参数，第三方登录返回后，如果重新转存，需要使用这个值
  /** 允许第三方分析使用Cookie */
  ALLOW_ANALYSIS = 'allow_analysis',
  IS_NEW_USER = 'pp_new_user', // 是否为新注册用户，官网注册后跳转云盘，如果是新用户则展示新手引导
  REFERER_LIST = 'pp_referer_list',
  FREE_DAYS = 'pp_free_days', // 官网注册赠送会员天数
  HIDE_LANG_CHANGE = 'pp_hide_lang_change', // 隐藏语言切换栏
  SHARE_PWD_CODE = 'pp_share_pwd_code',
  HIDDEN_SHARED_CONTENT_COVER = 'pp_hidden_shared_content_cover', // 0 | 1 是否暂时隐藏从搜索自动打开分享页上的遮罩，session
  GLOBAL_DISPLAY_MODE = 'pp_global_display_mode', // 这个配置跟随全局
  SHARED_DISPLAY_MODE = 'pp_shared_display_mode', // 这个配置只影响分享
  SSR_VIEW_TYPE = 'pp_ssr_view_type',
}

export enum RoutePath {
  HOME = '/',
  MOBILE_APP = '/mobile-app', // 移动端 - 下载页
  DESKTOP_APP = '/desktop-app', // 桌面端 - 下载页
  TV_APP = '/tv', // 电视端 - 下载页
  BROWSER_EXTENSION = '/browser-extension', // 浏览器扩展程序
  HELP = '/help', // 帮助中心
  CONTACT_US = '/contact-us', // 联系我们
  POLICY_USER_AGREEMENT = '/policy/user-agreement', // 用户协议
  POLICY_PRIVACY_POLICY = '/policy/privacy-policy', // 隐私政策
  POLICY_MEMBERSHIP_AGREEMENT = '/policy/membership-agreement', // 会员协议
  POLICY_ANTI_ABUSE = '/policy/anti-abuse', // 反滥用政策
  POLICY_CHILD_SEXUAL_ABUSE = '/policy/child-sexual-abuse', // 儿童性虐待政策
  POLICY_COPYRIGHT_INFRINGEMENT = '/policy/copyright-infringement', // 版权侵权政策
  POLICY_USER_AGREEMENT_USER_AGREEMENT = '/policy/user-agreement/user-agreement', // 用户协议
  FAQ = '/faq', // 常见问题
  INAPP_SHOP = '/inapp/shop', // 内购商城
  BLOG = '/blog', // 博客
  HELP_CENTER = '/help-center', // 帮助中心
}

export enum RoutePathOfHelp {
  COPY_LINK = 'help#copy-link',
  SYSTEM_SHARE = 'help#system-share',
  TELEGRAM_BOT = 'help#telegram-bot',
}

export const enum RouteQueryKey {
  ACTION = 'action',
  SCENE = 'scene',
  SHARE_PASSCODE = 's_code',
  HIDE_HEADER = 'hide_header',
  VIEW_TYPE = 'view',
  ORDER_TYPE = 'order',
}

/* 用于路由的 query, 进入页面之后的操作 */
export enum RouteQueryKeyActionValue {
  SHOW_TASK = 'show_task',
  OPEN_FILE = 'open_file',
  HIGHLIGHT_FILES = 'highlight_files',
  CREATE_TASK = 'create_task',
  SHOW_STORAGE_DIALOG = 'show_storage_dialog',
  SHOW_MOBILE_SIDEBAR = 'show_mobile_sidebar',
  MOVE_FILES = 'move_files',
  OPEN_REDEEM_BOX = 'open_redeem_box',
  SEARCH = 'search',
  OPEN_FEEDBACK = 'open_feedback',
  LOGIN_REQUIRED = 'login_required',
  SHOW_TRAFFIC_DIALOG = 'show_traffic_dialog',
  SHOW_INVITE_DIALOG = 'show_invite_dialog',
  SHOW_BEGINNER_DIALOG = 'show_beginner_dialog',
  SHOW_ACTIVITY_DIALOG = 'show_activity_dialog',
  SHOW_POPUP_WINDOW = 'show_popup_window',
  LOGIN_TO_DRIVE = 'login_to_drive', // 登录或者注册成功后，直接跳转云盘
  SHOW_LOGIN = 'show_login',
}

/* 使用 enum 限制可用的路由名称，防止使用时名称不在限制范围内 */
export const enum RoutePathOfDrive {
  ALL = '/drive/all',
  TRASH = '/drive/trash',
  RECENT = '/drive/recent',
  LOGIN = '/drive/login',
  PAYMENT = '/drive/payment',
  PAYMENT_STORAGE = '/drive/payment/storage',
  PAYMENT_TRAFFIC = '/drive/payment/traffic',
  ACCOUNT = '/drive/account',
  REFERRAL = '/referral',
}

/* 分享的状态 */
export const enum ShareStatus {
  OK = 'OK', // 有效
  PASS_CODE_EMPTY = 'PASS_CODE_EMPTY', // 需要输入提取码
  PASS_CODE_ERROR = 'PASS_CODE_ERROR', // 提取码错误
  MAX_RESTORE_COUNT = 'MAX_RESTORE_COUNT', // 超过最大转存次数
  EXPIRED = 'EXPIRED', // 已过期
  DELETED = 'DELETED', // 已删除
  SENSITIVE_RESOURCE = 'SENSITIVE_RESOURCE', // 包含敏感资源
  SENSITIVE_WORD = 'SENSITIVE_WORD', // 文件名包含敏感词
  AUDITING = 'AUDITING', // 审核中
  NOT_FOUND = 'NOT_FOUND', // 未找到
  PROHIBITED = 'PROHIBITED', // 分享在当前地区不可用
}

/* 分享转存后的状态 */
export const enum RestoreStatus {
  RESTORE_UNKNOWN = 'RESTORE_UNKNOWN',
  RESTORE_COMPLETE = 'RESTORE_COMPLETE',
  RESTORE_START = 'RESTORE_START',
}

/* 云盘的数据对象类型 */
export const enum DriveKind {
  FILE = 'drive#file',
  FILE_LIST = 'drive#fileList',
  FOLDER = 'drive#folder',
  TASK = 'drive#task',
  EVENT = 'drive#event',
}

export const enum ServerError {
  FILE_SPACE_NOT_ENOUGH = 'file_space_not_enough', // 空间不足
  TASK_DAILY_CREATE_LIMIT = 'task_daily_create_limit', // 创建任务次数达到上限
  FILE_NOT_FOUND = 'file_not_found', // 使用不存在的 parent_id 获取文件列表
  UNAUTHENTICATED = 'unauthenticated',
}

// TODO 某些状态，海外云盘可能没有，需要移除
export const enum PhaseType {
  UNKNOWN = 'PHASE_TYPE_UNKNOW', // 默认状态
  PENDING = 'PHASE_TYPE_PENDING', // 等待中
  RUNNING = 'PHASE_TYPE_RUNNING', // 进行中
  ERROR = 'PHASE_TYPE_ERROR', // 失败
  COMPLETE = 'PHASE_TYPE_COMPLETE', // 完成
  PAUSED = 'PHASE_TYPE_PAUSED', // 暂停
}

/* 审核状态，风控过滤结果 */
export const enum AuditStatus {
  UNKNOWN = 'STATUS_UNKNOW', // 未知
  OK = 'STATUS_OK', // 允许
  SENSITIVE_RESOURCE = 'STATUS_SENSITIVE_RESOURCE', // 敏感资源
  SENSITIVE_WORD = 'STATUS_SENSITIVE_WORD', // 文件名包含敏感词
}

export const enum CustomEventType {
  AFTER_LOGIN = 'AFTER_LOGIN', // 登录成功
  CLOSE_VIDEO_PLAYER = 'CLOSE_VIDEO_PLAYER', // 关闭视频播放器
  CLOSE_PICTURE_PLAYER = 'CLOSE_PICTURE_PLAYER', // 关闭图片浏览器
  SET_VIDEO_FREEZE = 'SET_VIDEO_FREEZE', // 冻结视频播放器
  FILE_MANAGER_CLOSE = 'FILE_MANAGER_CLOSE',
  LOGIN_FAILED = 'LOGIN_FAILED', // 登录失败
  LOGOUT_SUCCESS = 'LOGOUT_SUCCESS', // 退出登录成功
  PLAYER_MOUNT = 'PLAYER_MOUNT', // 播放器已挂载
  PLAYER_RESTORE = 'PLAYER_RESTORE',
  RESTORE_SAVING = 'RESTORE_SAVING',
  RESTORE_STATUS = 'RESTORE_STATUS',
  RESTORE_CLICK = 'RESTORE_CLICK',
  JUMP_TO_VIP = 'JUMP_TO_VIP', // 在播放器上直接打开会员弹窗
  WILL_JUMP_TO_WEB = 'SHARE_PAGE_WILL_JUMP_TO_WEB', // 即将跳转到云盘浏览
}

/* 依赖注入使用的名称 */
export const enum InjectionKey {
  SHARE = 'SHARE',
  SHARE_DETAIL = 'SHARE_DETAIL',
  SHOW_LOGIN_DIALOG = 'SHOW_LOGIN_DIALOG',
  SHARE_PREVIEW_WINDOW = 'SHARE_PREVIEW_WINDOW',
}

export const enum OSName {
  IOS = 'iOS',
  ANDROID = 'Android',
  MAC_OS = 'Mac OS',
  WINDOWS = 'Windows',
}

export const enum AppInstallPlatform {
  ANDROID_APK = 'android',
  APPLE_STORE = 'ios',
  GOOGLE_PLAY = 'gp',
  TV_APK = 'tv',
  WINDOWS = 'windows',
}

export const enum PolicyName {
  USER_AGREEMENT = 'user-agreement',
  PRIVACY_POLICY = 'privacy-policy',
  MEMBERSHIP_AGREEMENT = 'membership-agreement',
  ANTI_ABUSE = 'anti-abuse',
  CHILD_SEXUAL_ABUSE = 'child-sexual-abuse',
  COPYRIGHT_INFRINGEMENT = 'copyright-Infringement',
  POLICY_UPDATES = 'update',
}

export const enum ViewType {
  LIST = 'list',
  GRID = 'grid',
  SINGLE = 'single',
  FLOW = 'flow',
}

export enum FileOrder {
  NAME_ASC = 'NAME_ASC', // A-Z
  NAME_DESC = 'NAME_DESC', // Z-A
  // NOTICE 以下为接口入参定义
  TYPE_DESC = '3',
  MODIFY_TIME_ASC = '5',
  MODIFY_TIME_DESC = '6',
  SIZE_ASC = '7',
  SIZE_DESC = '8',
}

export enum OrderTypeQueryName {
  NAME_ASC = 'name_asc',
  NAME_DESC = 'name_desc',
  MODIFY_TIME_ASC = 'mod_asc',
  MODIFY_TIME_DESC = 'mod_desc',
  SIZE_ASC = 'size_asc',
  SIZE_DESC = 'size_desc',
}

/* 用于上报使用的 scene 参数 */
export const enum SceneInQuery4Track {
  BROWSER_EXTENSION = 'browser_extension',
  OFFICIAL_WEBSITE = 'official_website',
  CLOUD_PAGE = 'cloud_page',
  LANDING_PAGE = 'landing_page',
  HOME_RECENT = 'home_recent',
  SHARE_PAGE = 'share_page',
  STARRED_FILE = 'starred_file',
}

export const enum SettingKey {
  SAVE_OTHER_APP_FILES_IN_SEPARATE_FOLDERS = 'SAVE_OTHER_APP_FILES_IN_SEPARATE_FOLDERS',
  TEST_MODE = 'TEST_MODE',
  DEFAULT_FOLDER_BASED_ON_PLATFORM = 'defaultFolderBasedOnPlatform',
  FILTER_FILES_WHEN_CREATE = 'filterFilesWhenCreate',
  DISPLAY_SENSITIVE_SHARES = 'displaySensitiveShare',
  SHOW_SHARED_CONTENT_FROM_SEARCH = 'autoIdentifyShareCode', // 使用搜索打开分享页后，是否显示分享内容
}

/** 从不同场景触发的转存操作 */
export const enum RestoreScene {
  UNKNOWN = 'UNKNOWN',
  POPUP = 'POPUP',
  POPUP_MAC = 'POPUP_MAC',
  DETECT_DIALOG = 'DETECT_DIALOG',
  DETECT_DIALOG_MAC = 'DETECT_DIALOG_MAC',
  VIEW = 'VIEW',
  BAR = 'BAR',
}

/* 登录组件被调起的场景 */
export enum LoginScene {
  ADD_BUTTON = 'add_button', // 点击浏览器扩展程序的保存按钮，调起 iframe 打开资源落地页，再打开登录
  PLUGIN_ENTRY = 'plugin_entry', // 点击浏览器扩展程序图标调起登录
  CLOUD_PAGE = 'cloud_page', // 在登录页调起登录组件
  LANDING_PAGE = 'landing_page', // 在资源落地页调起登录组件
  PAYMENT_PAGE = 'payment_page', // 在支付页调起登录组件
  OFFICIAL_PAGE = 'official_page',
  URL_CHECKER = 'url_checker',
  SHARE_PAGE = 'share_page',
}

export const enum VipTaskStatus {
  SUCCESS = 'success', // 已完成
  INIT = 'init', // 未完成
  TO_GET = 'toget', // 待领取
  NEW_USER = '', // 新用户
}
